import { useMutation } from 'react-query';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { toast } from 'react-toastify';
import { login } from 'services/AuthService';
import { useTranslation } from 'react-i18next';

interface IUseLoginDTO {
  email: string;
  password: string;
}
export const useLogin = () => {
  const { t } = useTranslation();
  return useMutation(
    (params: IUseLoginDTO) => login(params.email, params.password),
    {
      onError: () => {
        toast.error(t('Invalid credentials'), {
          toastId: ReactMutationKeys.LOGIN,
        });
      },
      mutationKey: ReactMutationKeys.LOGIN,
    }
  );
};
